import _ from "lodash";
import { i18n } from "lib/i18n";
import { getItemTypeLocale } from "Utils/EntityFlowUtils";

// Shared initial selection state for sync status tables
export const INIT_SELECTION = {
  rowSelected: new Map(),
  pageItemSelected: new Set(),
  pageItemCourseSyncStatus: [],
};

export const STATUS_BASE_PATH = "sync-status";

export const SYNC_STATUS_CHILD_SEGMENT = {
  COURSE_PLAN: "course-plan",
  GRADING_CONFIGURATION: "grading-configuration",
  STANDARDS: "standards",
  UNIT_PLAN: "unit-plan",
  PLANNER: "planner",
};

export const PAGE_TYPES = {
  COURSE_PAGE: "COURSE_PAGE",
  GRADING_PAGE: "GRADING_PAGE",
  STANDARD_PAGE: "STANDARD_PAGE",
  UNIT_PLAN_PAGE: "UNIT_PLAN_PAGE",
  PLANNER_PAGE: "PLANNER_PAGE",
};

export const getSyncStatusChildMap = t => ({
  [SYNC_STATUS_CHILD_SEGMENT.COURSE_PLAN]: {
    id: SYNC_STATUS_CHILD_SEGMENT.COURSE_PLAN,
    routeName: "",
    displayName: t("course:course_components"),
    page: PAGE_TYPES.COURSE_PAGE,
  },
  [SYNC_STATUS_CHILD_SEGMENT.GRADING_CONFIGURATION]: {
    id: SYNC_STATUS_CHILD_SEGMENT.GRADING_CONFIGURATION,
    routeName: "grading-configuration",
    displayName: t("course:grading_configuration"),
    page: PAGE_TYPES.GRADING_PAGE,
  },
  [SYNC_STATUS_CHILD_SEGMENT.STANDARDS]: {
    id: SYNC_STATUS_CHILD_SEGMENT.STANDARDS,
    routeName: "standards",
    displayName: t("common:standard_other"),
    page: PAGE_TYPES.STANDARD_PAGE,
  },
  [SYNC_STATUS_CHILD_SEGMENT.UNIT_PLAN]: {
    id: SYNC_STATUS_CHILD_SEGMENT.UNIT_PLAN,
    routeName: "course-planner",
    withId: true,
    displayName: t("course:course_flow"),
    page: PAGE_TYPES.UNIT_PLAN_PAGE,
    entityType: "UNIT_PLAN",
  },
  [SYNC_STATUS_CHILD_SEGMENT.PLANNER]: {
    id: SYNC_STATUS_CHILD_SEGMENT.PLANNER,
    routeName: "course-planner",
    displayName: t("course:course_flow"),
    page: PAGE_TYPES.PLANNER_PAGE,
  },
});

export const RESOURCE_TYPES = {
  GRADING_CONFIGURATION: "GRADING_CONFIGURATION",
  LEARNING_COURSE_STANDARD_MAP: "LEARNING_COURSE_STANDARD_MAP",
  COURSE_PLAN_CHANGE_ROOT_SECTION: "COURSE_PLAN_CHANGE_ROOT_SECTION",
  UNIT_PLAN: "UNIT_PLAN",
  UNIT_PLAN_DETAILS: "UNIT_PLAN_DETAILS",
  ASSESSMENT: "ASSESSMENT",
  FOLDER: "FOLDER",
  FILE: "FILE",
  UNIT_FLOW_SECTION: "UNIT_FLOW_SECTION",
  PLANNER_FIELD: "PLANNER_FIELD",
  PLANNER_ELEMENT_NODE: "PLANNER_ELEMENT_NODE",
  GRADING_CONFIGURATION_SECTION: "GRADING_CONFIGURATION_SECTION",
  ACADEMIC_CRITERIA_SET_MAP: "ACADEMIC_CRITERIA_SET_MAP",
};

export const getEntityLabel = ({ resourceType, item, assessmentTypes }) => {
  const t = i18n.t;
  switch (resourceType) {
    case RESOURCE_TYPES.COURSE_PLAN_CHANGE_ROOT_SECTION:
      return t("course:course_flow");
    case RESOURCE_TYPES.LEARNING_COURSE_STANDARD_MAP:
      return t("common:standard_other");
    case RESOURCE_TYPES.GRADING_CONFIGURATION:
      return t("course:grading_configurations");
    case RESOURCE_TYPES.PLANNER_FIELD:
      return t("course:field");
    case RESOURCE_TYPES.PLANNER_ELEMENT_NODE:
      return t("common:standard");
    case RESOURCE_TYPES.GRADING_CONFIGURATION_SECTION:
    case RESOURCE_TYPES.ACADEMIC_CRITERIA_SET_MAP:
      return t("course:grading_configuration");
    default:
      return t(
        getItemTypeLocale({ item, assessmentTypes: assessmentTypes || {} })
      );
  }
};

export const getSyncStatusTableVariable = ({
  learningCourseId,
  syncStatusRoute,
  selectedSyncStatusFilter,
  searchText,
  isBlueprintCourse,
  selectedCourseIds,
}) => {
  const page = _.get(syncStatusRoute, "segmentDetail.page");
  const segmentChildId = _.get(syncStatusRoute, "segmentChildId");
  const isCoursesPage = _.isEqual(page, PAGE_TYPES.COURSE_PAGE);

  return {
    id: learningCourseId,
    filters: {
      status: isCoursesPage ? [] : selectedSyncStatusFilter ?? [],
      searchText: searchText || "",
      ...(!_.isNil(segmentChildId) ? { entityId: segmentChildId } : {}),
      page,
      ...(!isBlueprintCourse
        ? {
            teacherCourseIds: [learningCourseId],
          }
        : { teacherCourseIds: selectedCourseIds }),
    },
    skipCourseSyncStatus: !isBlueprintCourse,
    ...(isBlueprintCourse
      ? {
          courseSyncStatusFilters: {
            type: "BLUEPRINT_COURSE",
            learningCourseId,
            teacherCourseIds: [],
          },
        }
      : {}),
  };
};
